import "./bootstrap/axios";

import Vue from "vue";
import router from "./router";
import store from "./store";
import App from "./App.vue";

Vue.config.productionTip = false;

// Initialize Vue application
new Vue({
  el: "#app",
  router,
  store,
  render: (h) => h(App),
});

// Initialize authentication without blocking
// public routes such as Home, Brands and Products.
store.dispatch("auth/bootstrap").catch((error) => {
  console.error("Authentication initialization failed:", error);
});
